import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, PolicyState, State } from './combiner';

export const selectPolicyState = createFeatureSelector<State, PolicyState>(featureKey);

export const selectGetPolicyState = createSelector(selectPolicyState, (state: PolicyState) => state.getPolicy);
export const selectPutPolicyState = createSelector(selectPolicyState, (state: PolicyState) => state.putPolicy);
export const selectPolicyActionsState = createSelector(selectPolicyState, (state: PolicyState) => state.actions);
export const selectDifferenceState = createSelector(selectPolicyState, (state: PolicyState) => state.difference);
